import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import Icon from '../../common/containers/icon';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
import NumberInput from '../../common/controls/numberInput';
import SinglePicker from '../../common/controls/singlePicker';
const ContractSpecDryFilmItem = _ref => {
  let onRemove = _ref.onRemove,
    onChange = _ref.onChange,
    index = _ref.index,
    coatTypeList = _ref.coatTypeList,
    active = _ref.active,
    _ref$active = _ref.active,
    coatTypeID = _ref$active.coatTypeID,
    dftMin = _ref$active.dftMin,
    dftMax = _ref$active.dftMax;
  const handleCoatTypeID = value => onChange(index, 'coatTypeID', value);
  const handleDftMin = value => onChange(index, 'dftMin', value);
  const handleDftMax = value => onChange(index, 'dftMax', value);
  const confirmOnRemoveFields = ['dftMin', 'dftMax'];
  const handleRemove = () => onRemove(index);
  // this calls onRemove IF either
  //   a) there is no data to confirm removing in the item, or
  //   b) the user says it is okay to remove the all the data.
  const confirmRemove = () => removeItemWithConfirm(active, 'dry film', confirmOnRemoveFields, handleRemove);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    disabled: true,
    label: "Coat Type",
    onChange: handleCoatTypeID,
    options: coatTypeList,
    placeholder: "Required...",
    returnValueKey: "id",
    value: coatTypeID
  })), /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "\xA0"), /*#__PURE__*/React.createElement(Button, {
    name: "removeDryFilm",
    size: "sm",
    className: "form-control t-csdf-remove-dry-film",
    onClick: confirmRemove
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Coat"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Dry Film Thickness"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: dftMin,
    entity: "ContractSpecDryFilmRange",
    field: "dftMin",
    onChange: handleDftMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: dftMax,
    entity: "ContractSpecDryFilmRange",
    field: "dftMax",
    onChange: handleDftMax
  }))))));
};
ContractSpecDryFilmItem.propTypes = {
  index: PropTypes.number.isRequired,
  active: PropTypes.shape({
    coatTypeID: PropTypes.string,
    dftMin: PropTypes.number,
    dftMax: PropTypes.number
  }).isRequired,
  coatTypeList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
export default ContractSpecDryFilmItem;